<template>
<!-- 头条 -->
    <div class="news">
        <div class="container">

            <!-- left -->
            <div class="leftbox">
                <img src="../../assets/static/index/toutiao.png" alt="">
            </div>

            <!-- midele -->
            <div class="middle">
                <el-carousel height="38px" direction="vertical" :autoplay="true"  indicator-position="none" >
                    <el-carousel-item v-for="(item, index) in TouTiao" :key="index">
                        <h3 class="medium" @click="showNewsDetail( item )">{{ item.news_title }}</h3>
                    </el-carousel-item>
                </el-carousel>
            </div>

            <!-- right -->
            <div class="right" @click="showMore()">
                <span class="aw">
                    {{ leftArrow }}
                </span>
                <span>更多头条</span>
                <span class="aw"> 
                   {{ rightArrow }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                leftArrow: ">>>",
                rightArrow: "<<<",
                newsList: [
                    "习近平向全国广大教师和教育工作者致以节日祝贺和诚挚慰问",
                    "习近平向全国广大教师和教育工作者致以节日祝贺和诚挚慰问",
                    "习近平向全国广大教师和教育工作者致以节日祝贺和诚挚慰问",
                ],
            }
        },
        props: {
            TouTiao: Array
        },
        methods: {
            // 展示新闻详情
            showNewsDetail ( item ) {
                this.$router.push({
                    path: `/NewsDetail/${item.news_id}`,
                    query: {
                        cate_id: item.cate_id
                    }
                })
            },
            showMore(){
                this.$router.push({
                    path:"/moreNewsList",
                    query: {
                        cate_id: "",
                        isSearch: 0,
                        keyword: "",
                    }
                })
            }
        },
    }
</script>

<style lang="scss" scoped>
.news {
    width: 100%;
    .container {
        width: 1200px;
        height: 90px;
        box-sizing: border-box;
        padding: 20px;
        margin: 30px auto;
        display: flex;
        align-items: center;
        background-color: #fff;
        box-shadow: 0px 5px 20px 0px rgba(222, 17, 22, 0.06);
        .left {
            width: 80px;
        }
        .right {
            width: 170px;
            font-size: 14px;
            cursor: pointer;
            color: #306EC8;
            .aw {
                color: #E5E5E5;
            }
        }
        .middle {
            flex: 1;
            cursor: pointer;
            margin: 0 20px;
            font-size: 24px;
            .medium {
                line-height: 30px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 24px;
            }
        }
    }
}
</style>